import { EBrowser } from '@enums/common';

export const getBrowser = () => {
	const test = (regexp: RegExp) => regexp.test(window.navigator.userAgent);

	switch (true) {
		case test(/edg/i):
			return EBrowser.microsoftEdge;
		case test(/trident/i):
			return EBrowser.microsoftInternetExplorer;
		case test(/firefox|fxios/i):
			return EBrowser.mozillaFirefox;
		case test(/opr\//i):
			return EBrowser.opera;
		case test(/ucbrowser/i):
			return EBrowser.ucBrowser;
		case test(/samsungbrowser/i):
			return EBrowser.samsungBrowser;
		case test(/chrome|chromium|crios/i):
			return EBrowser.googleChrome;
		case test(/safari/i):
			return EBrowser.appleSafari;
		default:
			return null;
	}
};

export const setSessionStorage = (key: string, payload: string): void => (
	sessionStorage.setItem(key, JSON.stringify(payload))
);

export const getSessionStorage = (key: string): string | null => {
	const payload = sessionStorage.getItem(key);

	return payload ? JSON.parse(payload) : null;
};

export const clearSessionStorage = (key: string): void => {
	(key ? sessionStorage.removeItem(key) : sessionStorage.clear());
};
